import useTags from './useTags';

export default useTags;
